<template>
  <div id="home_map_wrap">
    <div id="home_map"></div>
    <p v-if="false" @click="change" id="model">
      {{ isMarkerClusterer ? "展开模式" : "气泡模式" }}
    </p>
  </div>
</template>
<script>
import Theaters from 'tdesign-icons-vue/lib/components/theaters';

var map;
var t;
var cluster = null;
var markers = [];
export default {
  data() {
    return {
      gpsData: [],
      isMarkerClusterer: false,
    };
  },
  methods: {
    getDeviantCarList() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-upf/data/getCarDis",
        data: { returnCoord: 2 },
      }).then((res) => {
        var data = res.data.data;
        this.gpsData = [];
        for (let i = 0; i < data.length; i++) {
          var obj = {
            lng: data[i].x,
            lat: data[i].y,
            name: data[i].carNo,
            alarmList: [],
            icon: data[i].carTypeIcon,
            direction: data[i].direction,
            status: data[i].deviceStatus,
            directionDegree: data[i].directionDegree,
          };
          this.gpsData.push(obj);
        }
        if (this.gpsData.length > 30) {
          this.isMarkerClusterer = true;
        }
        this.showPoints();
      });
    },
    showPoints() {
      var carList = this.gpsData;
      var baseSrc = this.axios.platConfig.fileUri + "mapicon/";

      map.clearMap();
      markers = [];

      for (var i = 0, myMarker; i < carList.length; i++) {
        var direction = 1;
        var angle = carList[i].directionDegree;
        if (carList[i].icon.indexOf("001") != -1) {
          angle = 0;
        }
        if (carList[i].icon.indexOf("002") != -1) {
          direction = carList[i].direction;
        }
        var imgsrc =
          baseSrc +
          carList[i].icon +
          "/" +
          carList[i].status +
          "/" +
          //data_info[i].direction +
          direction +
          ".gif";
        let marks = new AMap.Marker({
          map: map,
          position: [carList[i].lng, carList[i].lat],
          //angle: 0,
          content:
            "<div class='lymapicon'><img style='transform:rotate(" +
            angle +
            "deg);' src='" +
            imgsrc +
            "'/>" +
            "<p>" +
            carList[i].name +
            "</p></div>",
          offset: new AMap.Pixel(-13, -30),
        });
        markers.push(marks);
      }
      map.add(markers)
      map.setFitView(markers);
      // 非气泡模式
      if (!this.isMarkerClusterer) {
        markers = [];
      }

      map.plugin(["AMap.MarkerClusterer"], function () {
        cluster = new AMap.MarkerClusterer(map, markers, {
          maxZoom: 10,
        });
      });
    },

    getPoints() {
      this.axios({
        method: "post",
        url: this.axios.rule + "/marker/list",
        data: {},
      }).then((res) => {
        var data = res.data.data.dataList;
        this.utils.showPoints(map, data, true);
      });
    },
    change() {
      this.isMarkerClusterer = !this.isMarkerClusterer;
      this.showPoints();
    },
    drawMap() {
      map = new AMap.Map("home_map", {
        resizeEnable: true,
      });
      //this.utils.setMap(map);
      //  map.setMapStyle("amap://styles/normal");
      // map.setMapStyle('amap://styles/blue');
     
      //map.setMapStyle("amap://styles/6bd83b3bf912d2e1c2961f735685146f");
      var that = this;
      map.on("complete", function (ev) {
        that.getPoints(); 
        that.getDeviantCarList();
         map.setMapStyle("amap://styles/blue");
      });
    },
  },
  mounted() {

    setTimeout(() => {

      this.drawMap();
    }, 800);



  },

};
</script>
<style lang="">
#home_map_wrap {
  width: 100%;
  height: 100%;
  position: relative;
}
#home_map {
  width: calc(100% - 10px);
  height: calc(100% - 10px);
  color: #333;
  margin: auto;
}
#home_map .lymapicon {
  text-align: center;
  margin-left: -50px;
  width: 100px;
}
#home_map .lymapicon img {
  width: 30px;
}
#home_map .lymapicon p {
  background: #30327d;
}
#model {
  cursor: pointer;
  position: absolute;
  bottom: 20px;
  left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/feiyong/ecmap.vue